// extracted by mini-css-extract-plugin
export default {"MyDi":"accordion_MyDi__oQvTi","maindivv":"accordion_maindivv__w7AOc"};